import {apiService} from "../api.service";
import {TimezoneLabeled} from "../../models/timezone/timezone";

export class TimezoneService {
    public async getAll(): Promise<TimezoneLabeled[]> {
        return (await apiService.get<TimezoneLabeled[]>("timezones")).data;
    }
}

export const timezoneService = new TimezoneService();